/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_MoreInputs */

const en_mk_price_more = /** @type {(inputs: Mk_Price_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all billing periods, currencies, models, and allowances on the pricing page. Guided support and your own AI provider usage are charged separately.`)
};

const id_mk_price_more = /** @type {(inputs: Mk_Price_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua periode, mata uang, model, dan kuota tersedia di halaman harga. Pendampingan dan penggunaan layanan AI sendiri dihitung terpisah.`)
};

/**
* | output |
* | --- |
* | "See all billing periods, currencies, models, and allowances on the pricing page. Guided support and your own AI provider usage are charged separately." |
*
* @param {Mk_Price_MoreInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_more = /** @type {((inputs?: Mk_Price_MoreInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_MoreInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_more(inputs)
	return en_mk_price_more(inputs)
});